import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../utils/classnames';
import { isArray } from 'lodash';
export var ProductLable = function ProductLable(_ref) {
  var labelData = _ref.labelData,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'product' : _ref$type;
  if (!labelData) {
    return _jsx(_Fragment, {});
  }
  var data = type === 'product' ? labelData.split(' ').filter(function (i) {
    return i;
  }) : labelData;
  return _jsx(_Fragment, {
    children: isArray(data) ? data.map(function (item, index) {
      return _jsx("div", Object.assign({
        className: classNames('px-0.5 mobile:text-px', 'cq-pc:px-1 cq-pc:text-1xs', className)
      }, {
        children: item
      }), index);
    }) : _jsx("div", Object.assign({
      className: classNames('px-0.5 mobile:text-px', 'cq-pc:px-1 cq-pc:text-1xs', className)
    }, {
      children: data
    }))
  });
};